import { Link } from '@/i18n/navigation'
import styles from './ExtraLabel.module.css'
import { PropsWithChildren } from 'react'
import ChevronRightIcon from '@/assets/img/Icon_ChevronRight.svg'

export enum ExtraLabelTypes {
  INFO = 'info',
  HIGHLIGHT = 'highlight',
  CTA = 'cta'
}

type BaseProps = PropsWithChildren<{
  type?: ExtraLabelTypes
  content?: string
}>

type ExtraLabelLinkProps = BaseProps &
  Omit<React.ComponentProps<typeof Link>, 'children'> & {
    href: React.ComponentProps<typeof Link>['href']
  }

type ExtraLabelDivProps = BaseProps &
  Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> & {
    href?: never
  }

type ExtraLabelProps = ExtraLabelLinkProps | ExtraLabelDivProps

export default function ExtraLabel ({ type = ExtraLabelTypes.INFO, content, className, children, ...rest }: ExtraLabelProps) {
  const fontClassName = type === ExtraLabelTypes.INFO ? 'bodyTextSmall' : 'bodyTextLargeStrong'
  const labelClassName = `${fontClassName} ${styles.extraLabel} ${styles[type]} ${className ?? ''}`

  if (rest.href !== undefined) {
    const { href, ...linkRest } = rest

    return (
      <Link href={href} className={labelClassName} {...linkRest}>
        <p>{content}</p>
        {type === ExtraLabelTypes.CTA &&
          <ChevronRightIcon className={styles.icon} />
        }
      </Link>
    )
  }

  return (
    <div className={labelClassName} {...rest} >
      <p>{content}</p>
    </div>
  )
}